import ResetPasswordView from './ResetPassword.view';
export * from './ResetPassword.view';

export const ResetPassword = (props) => ResetPasswordView(props);

export default ResetPassword;

